export function encode(arg: string): string {
  return encodeURIComponent(arg).replace('(', '%28').replace(')', '%29');
}

export function decode(arg: string): string {
  return decodeURIComponent(arg).replace('%2F', '/');
}
